import { styled } from "@mui/material";

export const BoldSpan = styled("span")(() => ({
  fontWeight: 600,
}));
